import { seenModalIdsAtom } from '@/atoms/modalQueueAtoms';
import { usePaywallStates as useAppPaywallStates } from '@/atoms/paywallAtoms';
import { useMutateMarkModalAsViewed as useAppMutateMarkModalAsViewed } from '@/hooks/mutation/useMutateMarkModalAsViewed';
import { useQueryCombinedSessions as useAppQueryCombinedSessions } from '@/hooks/query/useQueryCombinedSessions';
import { remoteIntroPromoAnalyticsPorts } from '@/models/analytics/features/trackRemoteIntroPromoAnalytics';
import { isOnPrem as readIsOnPrem } from '@/utils/buildProfile';
import { useReverseTrial, useUserBillingInfo, useUserTier } from '@heidi/commerce/data';
import type { RemoteIntroPromoHost } from '@heidi/growth';
import { useAtomValue, useSetAtom } from 'jotai';

/**
 * One module constant of call-throughs. Each member reads its binding when
 * called, and a host built per render re-fires the impression effects.
 */
export const remoteIntroPromoHost: RemoteIntroPromoHost = {
  useQueryCombinedSessions: () => {
    const { sessions } = useAppQueryCombinedSessions();
    return { sessions: sessions || null };
  },
  useUserTier: () => useUserTier(),
  useUserBillingInfo: () => {
    const { data } = useUserBillingInfo();
    return { data };
  },
  useReverseTrial: () => useReverseTrial(),
  get isOnPrem() {
    return readIsOnPrem;
  },
  useSeenModalIds: () => useAtomValue(seenModalIdsAtom),
  useSetSeenModalIds: () => useSetAtom(seenModalIdsAtom),
  useMutateMarkModalAsViewed: () => {
    const { mutate } = useAppMutateMarkModalAsViewed();
    return {
      mutate: (variables) => {
        mutate(variables);
      },
    };
  },
  usePaywallStates: () => {
    const { toggleClinicianUpgradeModal } = useAppPaywallStates();
    return { toggleClinicianUpgradeModal };
  },
  get analytics() {
    return remoteIntroPromoAnalyticsPorts;
  },
};
